<!-- src/components/flipdish/Widget.vue -->
<!-- Flipdish delivery/ordering widget component -->
<template>
  <div id="flipdish-menu" data-restaurant="br14225"></div>
</template>

<script>
/* eslint-disable no-useless-escape */
import postscribe from "postscribe";

export default {
  name: "Flipdish-Widget",
  mounted: function () {
    // Inject the Flipdish script after component mounts
    postscribe(
      "#flipdish-menu",
      `<script id="flipdish-script" type="text/javascript" charset="UTF-8" src="https://web-order.flipdish.co/client/productionwlbuild/latest/static/js/main.js"><\/script>`
    );
  },
};
</script>
